import { ROUTES } from "@repo/core/routes";
import { FlowConfig, TransactionFlowType } from "./types";
import { TransactionItemTypeLetterEnum } from "@repo/core/constants/transactions";
import { TransactionOperationEnum } from "@repo/core/enums/receipts";

const PurchaseFlowConfig: FlowConfig = {
  type: TransactionFlowType.PURCHASE,
  title: "Compra",
  entryPoint: ROUTES.newTransactionCaptureOptions,
  transactionType: TransactionItemTypeLetterEnum.COMPRA,
  transactionOperation: TransactionOperationEnum.PURCHASE,
  routes: {
    [ROUTES.newTransactionCaptureOptions]: {
      title: "Meio de captura",
      next: ROUTES.newTransactionIdentity,
      previous: ROUTES.sales,
      showConfirmStoreModal: true
    },
    [ROUTES.newTransactionQRCode]: {
      title: "Ler QR Code",
      next: ROUTES.newTransactionValue,
      previous: ROUTES.newTransactionCaptureOptions,
      showConfirmStoreModal: false
    },
    [ROUTES.newTransactionIdentity]: {
      title: "Compra",
      next: ROUTES.newTransactionValue,
      previous: ROUTES.newTransactionCaptureOptions,
      showConfirmStoreModal: false
    },
    [ROUTES.newTransactionValue]: {
      title: "Compra",
      next: ROUTES.newTransactionFidelityOptions,
      previous: ROUTES.newTransactionIdentity
    },
    [ROUTES.newTransactionFidelityOptions]: {
      title: "Programa de Fidelidade",
      next: ROUTES.newTransactionPaymentOptions,
      previous: ROUTES.newTransactionValue
    },
    [ROUTES.newTransactionPaymentOptions]: {
      title: "Tipo de parcelamento",
      previous: ROUTES.newTransactionFidelityOptions
    },
    [ROUTES.newTransactionInstallments]: {
      title: "Parcelamento",
      next: ROUTES.newTransactionReview,
      previous: ROUTES.newTransactionPaymentOptions
    },
    [ROUTES.newTransactionReview]: {
      title: "Revisão",
      next: ROUTES.newTransactionConfirm,
      previous: ROUTES.newTransactionInstallments
    },
    [ROUTES.newTransactionConfirm]: {
      title: "Confirmar Pagamento",
      next: ROUTES.newTransactionReceipt,
      previous: ROUTES.newTransactionReview
    },
    [ROUTES.newTransactionReceipt]: {
      title: "Comprovante de Transação"
    }
  }
};

const EmergencyWithdrawFlowConfig: FlowConfig = {
  type: TransactionFlowType.EMERGENCY_WITHDRAW,
  title: "Saque Emergencial",
  entryPoint: ROUTES.newTransactionIdentity,
  transactionType: TransactionItemTypeLetterEnum.SAQUE,
  transactionOperation: TransactionOperationEnum.WITHDRAW,
  routes: {
    [ROUTES.newTransactionIdentity]: {
      title: "Saque Emergencial",
      previous: ROUTES.sales,
      next: ROUTES.newTransactionValue,
      showConfirmStoreModal: true
    },
    [ROUTES.newTransactionValue]: {
      title: "Saque Emergencial",
      next: ROUTES.newTransactionFidelityOptions,
      previous: ROUTES.newTransactionIdentity
    },
    [ROUTES.newTransactionFidelityOptions]: {
      title: "Programa de Fidelidade",
      next: ROUTES.newTransactionPaymentOptions,
      previous: ROUTES.newTransactionValue
    },
    [ROUTES.newTransactionPaymentOptions]: {
      title: "Tipo de parcelamento",
      previous: ROUTES.newTransactionFidelityOptions
    },
    [ROUTES.newTransactionInstallments]: {
      title: "Parcelamento",
      next: ROUTES.newTransactionReview,
      previous: ROUTES.newTransactionPaymentOptions
    },
    [ROUTES.newTransactionReview]: {
      title: "Revisão",
      next: ROUTES.newTransactionConfirm,
      previous: ROUTES.newTransactionPaymentOptions
    },
    [ROUTES.newTransactionConfirm]: {
      title: "Confirmar Saque",
      next: ROUTES.newTransactionReceipt,
      previous: ROUTES.newTransactionReview
    },
    [ROUTES.newTransactionReceipt]: {
      title: "Comprovante de Transação"
    }
  }
};
const FidelityScoreFlowConfig: FlowConfig = {
  type: TransactionFlowType.FIDELITY_SCORE,
  title: "Pontuação de Fidelidade",
  entryPoint: ROUTES.newTransactionIdentity,
  transactionType: TransactionItemTypeLetterEnum.PONTUACAO,
  transactionOperation: TransactionOperationEnum.POINTS,
  routes: {
    [ROUTES.newTransactionIdentity]: {
      title: "Pontuação de Fidelidade",
      previous: ROUTES.sales,
      next: ROUTES.newTransactionValue,
      showConfirmStoreModal: true
    },
    [ROUTES.newTransactionValue]: {
      title: "Pontuação de Fidelidade",
      next: ROUTES.newTransactionConfirm,
      previous: ROUTES.newTransactionIdentity
    },
    [ROUTES.newTransactionConfirm]: {
      title: "Confirmar Pontuação",
      next: ROUTES.newTransactionReceipt,
      previous: ROUTES.newTransactionValue
    },
    [ROUTES.newTransactionReceipt]: {
      title: "Comprovante de Transação"
    }
  }
};

const BonusRetrievalFlowConfig: FlowConfig = {
  type: TransactionFlowType.BONUS_RETRIEVAL,
  title: "Resgate de Bônus",
  entryPoint: ROUTES.newTransactionIdentity,
  transactionType: TransactionItemTypeLetterEnum.PONTUACAO,
  transactionOperation: TransactionOperationEnum.BONUS_RETRIEVAL,
  routes: {
    [ROUTES.newTransactionIdentity]: {
      title: "Resgate de Bônus",
      previous: ROUTES.sales,
      next: ROUTES.newTransactionFidelityOptions,
      showConfirmStoreModal: true
    },
    [ROUTES.newTransactionFidelityOptions]: {
      title: "Programa de Fidelidade",
      next: ROUTES.newTransactionConfirm,
      previous: ROUTES.newTransactionIdentity
    },
    [ROUTES.newTransactionConfirm]: {
      title: "Confirmar Pontuação",
      next: ROUTES.newTransactionReceipt,
      previous: ROUTES.newTransactionFidelityOptions
    },
    [ROUTES.newTransactionReceipt]: {
      title: "Comprovante de Transação"
    }
  }
};

export const TRANSACTION_FLOWS: Record<TransactionFlowType, FlowConfig> = {
  [TransactionFlowType.PURCHASE]: PurchaseFlowConfig,
  [TransactionFlowType.EMERGENCY_WITHDRAW]: EmergencyWithdrawFlowConfig,
  [TransactionFlowType.FIDELITY_SCORE]: FidelityScoreFlowConfig,
  [TransactionFlowType.BONUS_RETRIEVAL]: BonusRetrievalFlowConfig
};
